import React from 'react'

const TeamPart = () => {
  return (
    <div>
       <div className='team-container'>
        <div className='team-member'>
        <div className='team-1'>
            <a href='https://www.linkedin.com/in/rama-devi-131b54277/' target='_blank' rel='noopener noreferrer'>
            <img src='/Rama.jpg' alt='Faculty' className='ankitamam' />
            <div style={{lineHeight:'2px',textAlign:'center'}}>
            <p style={{fontSize:'0.5rem'}}>Rama`</p>
            <p style={{fontSize:'0.5rem'}}>Graphic Design Executive</p></div></a>
        </div>
        <div className='team-2'>
        <a href='https://www.linkedin.com/in/rohan-raghav-b0b07a24a/' target='_blank' rel='noopener noreferrer'>
            <img src='/Rohan.jpeg' alt='Faculty' className='ankitamam' />
            <div style={{lineHeight:'2px',textAlign:'center'}}>
            <p style={{fontSize:'0.5rem'}}>Rohan Raghav</p>
            <p style={{fontSize:'0.5rem', maxWidth:'100px',lineHeight:'10px'}}>Full Stack Developer</p></div></a>
        </div>
        <div className='team-1'>
        <a href='https://www.linkedin.com/in/hem-jakhar/' target='_blank' rel='noopener noreferrer'>
            <img src='/Ham.jpg' alt='Faculty' className='ankitamam' />
            <div style={{lineHeight:'2px',textAlign:'center'}}>
            <p style={{fontSize:'0.5rem'}}>Hem Jakhar</p>
            <p style={{fontSize:'0.5rem'}}>Graphic designer and editor</p></div></a>
        </div>
        <div className='team-2'>
        <a href='https://www.linkedin.com/in/tarun-baliyan-201443250/' target='_blank' rel='noopener noreferrer'>
            <img src='/Tarun.jpg' alt='Faculty' className='ankitamam' />
            <div style={{lineHeight:'2px',textAlign:'center'}}>
            <p style={{fontSize:'0.5rem'}}>Tarun Baliyan</p>
            <p style={{fontSize:'0.5rem', maxWidth:'100px',lineHeight:'10px'}}>Graphic Designer</p></div></a>
        </div>
        </div>
        <div className='team-member'>
        <div className='team-1'>
            <a href='https://www.linkedin.com/in/jc-chinmayjain' target='_blank' rel='noopener noreferrer'>
            <img src='/Chinmay.jpg' alt='Faculty' className='ankitamam' />
            <div style={{lineHeight:'2px',textAlign:'center'}}>
            <p style={{fontSize:'0.5rem'}}>Chinmay Jain</p>
            <p style={{fontSize:'0.5rem'}}>Marketing Intern</p></div></a>
        </div>
        <div className='team-2'>
        <a href='http://www.linkedin.com/in/karanpreetsingh462' target='_blank' rel='noopener noreferrer'>
            <img src='/Karanpreet.jpg' alt='Faculty' className='ankitamam' />
            <div style={{lineHeight:'2px',textAlign:'center'}}>
            <p style={{fontSize:'0.5rem'}}>Karanpreet Singh</p>
            <p style={{fontSize:'0.5rem', maxWidth:'100px',lineHeight:'10px'}}>Content writer</p></div></a>
        </div>
        <div className='team-1'>
        <a href='https://www.linkedin.com/in/shiv-chauhan-7a8f05' target='_blank' rel='noopener noreferrer'>
            <img src='/Shiv.png' alt='Faculty' className='ankitamam' />
            <div style={{lineHeight:'2px',textAlign:'center'}}>
            <p style={{fontSize:'0.5rem'}}>Shiv Chauhan</p>
            <p style={{fontSize:'0.5rem'}}>Content Writer</p></div></a>
        </div>
        <div className='team-2'>
        <a href='https://www.linkedin.com/in/praveen-kumar-3a211628b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank' rel='noopener noreferrer'>
            <img src='/Praveen.jpg' alt='Faculty'  className='ankitamam' />
            <div style={{lineHeight:'2px',textAlign:'center'}}>
            <p style={{fontSize:'0.5rem'}}>Praveen Kumar </p>
            <p style={{fontSize:'0.5rem', maxWidth:'100px',lineHeight:'10px'}}>Technical Support</p></div></a>
        </div>
        </div>
        <div className='team-member'>
        <div className='team-1'>
        <a href='http://linkedin.com/in/azkiya-qamar-00263524b' target='_blank' rel='noopener noreferrer'>
            <img src='/Azkiya.jpg' alt='Faculty' className='ankitamam' />
            <div style={{lineHeight:'2px',textAlign:'center'}}>
            <p style={{fontSize:'0.5rem'}}>Azkiya Qamar</p>
            <p style={{fontSize:'0.5rem'}}>SMM Intern</p></div></a>
        </div>
        <div className='team-2'>
        <a href='https://www.linkedin.com/in/shatakshi-bhardwaj-445295281?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank' rel='noopener noreferrer'>
            <img src='/Shatakshi.jpg' alt='Faculty'  className='ankitamam' />
            <div style={{lineHeight:'2px',textAlign:'center'}}>
            <p style={{fontSize:'0.5rem'}}>Shatakshi Bhardwaj </p>
            <p style={{fontSize:'0.5rem', maxWidth:'100px',lineHeight:'10px'}}>Graphic designer intern</p></div></a>
        </div>
        <div className='team-1'>
        <a href='https://www.linkedin.com/in/sushilkumarpatra17a/' target='_blank' rel='noopener noreferrer'>
            <img src='/Sushil.jpg' alt='Faculty' className='ankitamam' />
            <div style={{lineHeight:'2px',textAlign:'center'}}>
            <p style={{fontSize:'0.5rem'}}>Sushil Kumar Patra</p>
            <p style={{fontSize:'0.5rem', maxWidth:'100px',lineHeight:'10px'}}>HR Intern/ Event Coordinator</p></div></a>
        </div>
        </div>
        </div>
    </div>
  )
}

export default TeamPart
